import { useSelector } from "react-redux";

import { TAppState } from "store/root.store";

export const useDocumentSelector = () => useSelector((state: TAppState) => state.documentsReducer);
